import axios from 'axios';
import { ReferralBonusActions } from './referralBonusAction';
import { showSuccessSnackbar } from '../../snackBar/snackBar.action';

export const createReferralBonusAsync = (values, setShowReferralModal) => {
    return async (dispatch, getState) => {
        try {
            dispatch(ReferralBonusActions.createReferralBonusStart());
            let response = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/referralBonus/add`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: values
            });
            if (response.data.statusCode === 201) {
                dispatch(ReferralBonusActions.createReferralBonusSuccess());
                setShowReferralModal(false)
                return dispatch(showSuccessSnackbar('success', "Referral bonus coins added successfully", 3000));
            }
            dispatch(ReferralBonusActions.createReferralBonusError());
            dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(ReferralBonusActions.createReferralBonusError(error?.response?.data?.message));
            return dispatch(showSuccessSnackbar("error", error?.response?.data?.message || "Error while adding referral bonus coins. Please try again later", 3000));
        }
    }
}

export const getAllReferralBonusAsync = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(ReferralBonusActions.getAllReferralBonusStart());
            let response = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/referralBonus/list`,
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.data.statusCode === 200) {
                return dispatch(ReferralBonusActions.getAllReferralBonusSuccess(response.data.data));
            }
            dispatch(ReferralBonusActions.getAllReferralBonusError());
            dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(ReferralBonusActions.getAllReferralBonusError());
            dispatch(showSuccessSnackbar('error', "Error while fetching Data.", 3000));
        }
    }
}

export const updateReferralBonusAsync = (referralBonusID, values, setShowReferralModal) => {
    return async (dispatch, getState) => {
        try {
            dispatch(ReferralBonusActions.updateReferralBonusStart());
            let response = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/referralBonus/${referralBonusID}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: values
            });
            if (response.data.statusCode === 200) {
                dispatch(ReferralBonusActions.updateReferralBonusSuccess());
                setShowReferralModal(false)
                return dispatch(showSuccessSnackbar('success', "Referral bonus coins updated successfully", 3000));
            }
            dispatch(ReferralBonusActions.updateReferralBonusError());
            return dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(ReferralBonusActions.updateReferralBonusError());
            dispatch(showSuccessSnackbar('error', "Error while updating. Please try again after sometime..", 3000));
        }
    }
}

export const updateReferralBonusStatusAsync = (referralBonusID, values) => {
    return async (dispatch, getState) => {
        try {
            dispatch(ReferralBonusActions.updateReferralBonusStart());
            let response = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/referralBonus/${referralBonusID}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: values
            });
            if (response.data.statusCode === 200) {
                dispatch(ReferralBonusActions.updateReferralBonusSuccess());
                const statusText = values.isActive ? "activated" : "deactivated";
                return dispatch(showSuccessSnackbar('success', `Referral bonus coins ${statusText} successfully`, 3000));
            }
            dispatch(ReferralBonusActions.updateReferralBonusError());
            return dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(ReferralBonusActions.updateReferralBonusError());
            dispatch(showSuccessSnackbar('error', "Error while updating status. Please try again after sometime..", 3000));
        }
    }
} 